import $ from 'jquery';
import { Loader } from "@googlemaps/js-api-loader"
window.addEventListener('px-ready',function(){
  if($('.px-map').length){
    $('.px-map').each(function(){
      var lat = $(this).attr('data-lat');
      var lng = $(this).attr('data-lng');
      var lang = $('.gmap-data').attr('data-lang');
      var key = $('.gmap-data').attr('data-key');
      console.log(lat + ' ' + lng);
      let loader;
      try {
        loader = new Loader({
          apiKey:key,
          version:'weekly',
          language: lang
        });
      } catch (error) {
        console.log('change de config');
        location.reload();
      }
      loader.load().then(()=>{
        console.log('map is up');
        //initMap(parseFloat(lat),parseFloat(lng),lang);
        var map;
        console.log('initmap');
        var glat = parseFloat(lat);
        var glng = parseFloat(lng);
        /*if(!glat || !glng){
          glat = 45.516340;
          glng = -73.559320;
        }*/
        console.log(glat + ' ' + glng);
        var reclat = 0.0004;
        var reclng = 0.000;
        map = new google.maps.Map(document.getElementById($(this).attr('id')), {
          center: {lat: glat+reclat, lng: glng+reclng},
          zoom: 15,
          language: lang,
          styles: [
            {
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#f5f5f5"
                }
              ]
            },
            {
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#616161"
                }
              ]
            },
            {
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "color": "#f5f5f5"
                }
              ]
            },
            {
              "featureType": "administrative.land_parcel",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#bdbdbd"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#eeeeee"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#e5e5e5"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#ffffff"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#dadada"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#616161"
                }
              ]
            },
            {
              "featureType": "road.local",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            },
            {
              "featureType": "transit.line",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#e5e5e5"
                }
              ]
            },
            {
              "featureType": "transit.station",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#eeeeee"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#c9c9c9"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            }
          ]
        });
        var icons = {
          bca : {icon: template_dir+'/assets_dist/images/pin.png'}
        }
        var features = [{
          position:new google.maps.LatLng(glat,glng),
          type:'bca'
        }]
        for (var i = 0; i < features.length; i++) {
          var marker = new google.maps.Marker({
            position: features[i].position,
            icon: icons[features[i].type].icon,
            map: map
          });
        };
      })
    })
  }
})